var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { WeakIdCache } from "../structures/WeakIdCache.js";
import { assertNever } from "../utils/assertNever.js";
const GLUE = "--";
const keyEndRegex = new RegExp(`${GLUE}\\d+$`);
class RealmKeyGenerator {
  static vaguelyAppearsToBeAKey(candidate) {
    return candidate.startsWith(`key${GLUE}`) && keyEndRegex.test(candidate);
  }
  static generateKey(parent, placeholderName, id, container) {
    return `key${GLUE}${this.parentStateIdCache.getOptionalKeyId(
      parent
    )}${GLUE}${placeholderName}${id}${GLUE}${this.markerIdCache.getId(container)}`;
  }
  static getRealmKey(id, blueprint) {
    const parent = blueprint.parent;
    let placeholderName;
    if (blueprint.type === "subTree") {
      placeholderName = blueprint.marker.placeholderName;
    } else if (blueprint.type === "listEntity") {
      placeholderName = blueprint.parent.blueprint.marker.placeholderName;
    } else if (blueprint.type === "hasOne") {
      placeholderName = blueprint.marker.placeholderName;
    } else {
      return assertNever();
    }
    return this.generateKey(
      parent,
      placeholderName,
      id.value,
      blueprint.type === "listEntity" ? blueprint.parent.blueprint.marker.fields : blueprint.marker.fields
    );
  }
}
// We're using this id, and not, well, the entity id, because it *SIGNIFICANTLY* reduces the complexity of
// entity id changes.
__publicField(RealmKeyGenerator, "parentStateIdCache", new WeakIdCache());
__publicField(RealmKeyGenerator, "markerIdCache", new WeakIdCache());
export {
  RealmKeyGenerator
};
//# sourceMappingURL=RealmKeyGenerator.js.map
